import { supportedTypes } from '@remote-com/mushu/src/components/Form/DynamicForm/helpers';
import {
  baseString,
  emailSchema,
  genericRequiredLabel,
  multiSelect,
  validateIsNumber,
} from '@remote-com/mushu/src/helpers/validationSchema';
import { ButtonInline } from '@remote-com/norma/core/button';
import {
  doesNotIncludePersonalEmailProviders,
  listToOptions,
} from 'remote-com-shared/components/ModalForm/helpers';
import { getAllCountries, reasonOptions } from 'remote-com-shared/data';
import { boolean } from 'yup';

export const fields = [
  {
    type: supportedTypes.TEXT,
    name: 'firstName',
    label: 'First name',
    required: true,
    schema: baseString.required(genericRequiredLabel),
  },
  {
    type: supportedTypes.TEXT,
    name: 'lastName',
    label: 'Last name',
    required: true,
    schema: baseString.required(genericRequiredLabel),
  },
  {
    type: supportedTypes.EMAIL,
    name: 'email',
    label: 'Work email',
    required: true,
    schema: emailSchema
      .required(genericRequiredLabel)
      .matches(doesNotIncludePersonalEmailProviders, 'Please enter your work email'),
  },
  {
    type: supportedTypes.TEXT,
    name: 'companyName',
    label: "Company's name",
    required: true,
    schema: baseString.required(genericRequiredLabel),
  },
  {
    type: supportedTypes.SELECT,
    name: 'companyHeadquarters',
    label: 'Where is the company established?',
    placeholder: 'Select country…',
    isControlled: true,
    displayLabel: true,
    required: true,
    options: listToOptions(getAllCountries()),
    transformValue: (option) => option.label,
    schema: baseString.required(genericRequiredLabel),
  },
  {
    type: supportedTypes.SELECT,
    name: 'reason',
    label: 'How can we help you?',
    placeholder: 'Select from list',
    isControlled: true,
    displayLabel: true,
    required: true,
    options: listToOptions(reasonOptions),
    transformValue: (option) => option.label,
    schema: baseString.required(genericRequiredLabel),
  },
  {
    type: supportedTypes.SELECT,
    name: 'targetCountries',
    label: 'Target countries',
    placeholder: 'Select countries...',
    isControlled: true,
    displayLabel: true,
    isMulti: true,
    required: true,
    options: listToOptions(getAllCountries()),
    schema: multiSelect.required(genericRequiredLabel),
  },
  {
    type: supportedTypes.NUMBER,
    name: 'numberOfEmployeesOrContractors',
    label: 'Number of employees you want to hire within 12 months',
    displayLabel: true,
    placeholder: 'Enter at least 1',
    required: true,
    schema: validateIsNumber.required(genericRequiredLabel),
  },
  {
    type: supportedTypes.NUMBER,
    name: 'employeeCount',
    label: 'How many people work at your company?',
    required: true,
    schema: validateIsNumber.required(genericRequiredLabel),
  },
  {
    type: supportedTypes.TEXT,
    name: 'promoCode',
    label: 'Promo code',
    schema: baseString,
  },
  {
    type: supportedTypes.ACK_CHECK,
    schema: boolean(),
    required: false,
    name: 'marketingConsent',
    label: (
      <span>
        I would also like to get news about your products and services. I acknowledge, read, and
        understood Remote&apos;s{' '}
        <ButtonInline
          href={`${process.env.NEXT_PUBLIC_PANDA_BASE_URL}/privacy-policy`}
          target="_blank"
        >
          Privacy Policy
        </ButtonInline>
      </span>
    ),
    defaultValue: true,
  },
];
